import { useEffect, FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateLogin, updateLogout } from '../api-integration/commonSlice';
import PropTypes from 'prop-types';

interface GuestGuardProps {
  children: ReactNode;
}

const NonAuthGuard: FC<GuestGuardProps> = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const redirectURL = sessionStorage.getItem("redirectURL");
  const redirectInProgress = sessionStorage.getItem("redirectInProgress");
  const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || 'false');

  useEffect(() => {
    const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || 'false');
    isLoggedIn ? dispatch(updateLogin()) : dispatch(updateLogout());
  }, []);

  const isSocialNetworkConnection = location.pathname.includes('/external');

  // If NOT logged in or social network connection, allow access
  if (!isLoggedIn || isSocialNetworkConnection) {
    return <>{children}</>;
  }

  // Allow if redirect is happening
  if (redirectURL || redirectInProgress) {
    return <>{children}</>;
  }

  // Logged in & NO redirect → block access to non-auth pages
  return <Navigate to="/home" replace />;
};

NonAuthGuard.propTypes = {
  children: PropTypes.node,
};

export default NonAuthGuard;